import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isUserLoggedin: false,
  signUpData: {},
  otpVerified: false,
  userInfo: {},
  cartCount: 0,
};

export const persistSlice = createSlice({
  name: "peristReducer",
  initialState,
  reducers: {
    isUserLogin: (state, action) => {
      state.isUserLoggedin = action.payload;
    },
    saveSignUpDetails: (state, action) => {
      state.signUpData = action.payload;
    },
    isOTPVerified: (state, action) => {
      state.otpVerified = action.payload;
    },
    saveUserData: (state, action) => {
      state.userInfo = action.payload;
    },
    saveCartCount: (state, action) => {
      state.cartCount = action.payload;
    },
  },
});

export const {
  isUserLogin,
  saveSignUpDetails,
  isOTPVerified,
  saveUserData,
  saveCartCount,
} = persistSlice.actions;
export default persistSlice.reducer;
